<template>
  <div class="component-wrap">
    <div class="pane">
      <span class="item active">当前属期数据统计</span>
      <span class="item">当前属期数据统计</span>
    </div>

    <div class="main-box">
      <div class="head-box">
        <div class="ins"></div>
        <div class="bold">税款所属期：</div>
        <div class="red">2023年10月</div>
        <div class="bold radio-box">

          <div class="layer"></div>

          报表类型：
          <label>
            <input type="radio" name="reportType" checked/>
            发票统计表
          </label>
          <label>
            <input type="radio" name="reportType"/>
            异常发票统计表
          </label>
        </div>
        <div class="grow"></div>
        <el-button type="primary" round
                   style="color: #FFFFFF;width: 80px;"
                   color="#17cacb"
                   @click="noCode"
        >打印
        </el-button>
        <el-button type="primary" round
                   style="color: #FFFFFF;width: 90px;"
                   color="#17cacb"
                   @click="statistQuery"
        >统计查询
        </el-button>
      </div>

      <div class="main-content">
        <div class="bt-op">
          <el-button
              v-if="currentStep == 0"
              type="primary"
              round
              style="color: #FFFFFF;width: 90px;"
              color="#15acee"
              @click="reqStatist"
          >申请统计
          </el-button>

          <el-button
              v-if="currentStep == 1 || currentStep == 2 || currentStep == 3"
              type="primary"
              round
              style="color: #FFFFFF;width: 90px;"
              color="#15acee"
              @click="rollbackStatist"
          >撤销统计
          </el-button>

          <el-button
              v-if="currentStep == 1 || currentStep == 2"
              type="primary"
              round
              style="color: #FFFFFF;width: 90px;margin-right: 10px;"
              color="#15acee"
              @click="confirmSign"
          >确认签名
          </el-button>
        </div>

        <div class="progress-wrap">
          <div class="step-bar">
            <div
                class="step-bar-active"
                :class="{
                   'step1': currentStep == 1,
                   'step2': currentStep == 2,
                   'step3': currentStep == 3,
                }"
            ></div>
          </div>
          <div class="step">
            <div class="item">
              <div class="s-position">1</div>
              <div class="s-label">申请统计</div>
            </div>
            <div class="item">
              <div class="s-position">2</div>
              <div class="s-label">统计完成</div>
            </div>
            <div class="item">
              <div class="s-position">3</div>
              <div class="s-label">确认签名</div>
            </div>
          </div>
        </div>

        <div class="ticket-table">
          <h3>发票统计表</h3>

          <div class="table-title">
            <div class="item">纳税人名称：...有限公司</div>
            <div class="item">纳税人识别号：...</div>
            <div class="item">所属月份：2023年10月</div>
            <div class="item">单位：（份、元）</div>
          </div>

          <table>
            <thead>
            <tr class="head">
              <td rowspan="2" class="out-wrapper">
                <div class="out"></div>
                <span>发票类型</span>
                <span>用途</span>
              </td>
              <td colspan="3">抵扣</td>
              <td colspan="3">不抵扣</td>
            </tr>

            <tr class="head">
              <td class="count">份数</td>
              <td class="money">金额</td>
              <td class="act">有效税额</td>
              <td class="count">份数</td>
              <td class="money">金额</td>
              <td class="act">有效税额</td>
            </tr>

            <tr v-if="tableList.length == 0">
              <td colspan="7">未找到符合条件的数据</td>
            </tr>

            <tr v-for="(item,idx) in tableList" :key="idx">
              <td>{{ item.name }}</td>
              <td>{{ item.count }}</td>
              <td>{{ item.money.toFixed(2) }}</td>
              <td>{{ item.actualTax.toFixed(2) }}</td>
              <td>{{ item.noCount }}</td>
              <td>{{ item.noMoney.toFixed(2) }}</td>
              <td>{{ item.noActualTax.toFixed(2) }}</td>
            </tr>

            </thead>
          </table>
        </div>
      </div>
    </div>

    <div class="main-box">
      <div class="head-box">
        <div class="ins"></div>
        <div class="bold">备注</div>
      </div>

      <div class="note-txt">
        1、本统计表包括当前税款所属期内所有勾选为抵扣和不抵扣的增值税发票；<br/>
        2、一个属期内对已勾选的发票支持多次申请统计操作；<br/>
        3、申报期内，对已勾选数据进行申请统计后，系统将自动锁定当期抵扣勾选操作；如需继续勾选发票，可在撤销统计成功后继续进行发票勾选或撤勾选操作；<br/>
        4、申报期内，申请统计完成后正式进行申报前，需在本平台对抵扣统计表进行签名确认操作；<br/>
        5、申报期内，对抵扣统计表签名确认后申报完成前，支持撤销统计，系统将自动撤销抵扣统计表和确认签名，撤销完成后可以继续勾选发票，修正完毕后需再次进行申请统计和确认签名操作。<br/>
      </div>
    </div>

    <input-cert-key-dialog
        v-model:visible="keyVis"
        @confirm="handleSave"
    />

  </div>
</template>

<script setup>
import {ElMessageBox} from "element-plus";
import Big from "big.js";
import {$emit, $on} from "vue-happy-bus";
import InputCertKeyDialog from "./InputCertKeyDialog.vue";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const queryParams = reactive({})

const currentStep = ref(0)

function noCode() {
  ElMessageBox.alert('此功能不在实训范围内', '提示', {
    confirmButtonText: 'OK',
    showClose: false,
    callback: () => {
    },
  })
}

const tableList = ref([])

function reqStatist() {
  currentStep.value = 1
  ElMessageBox.alert('已申请报表统计，请稍后查询统计报表！', '提示', {
    confirmButtonText: 'OK',
    showClose: false,
  })
}

function statistQuery() {
  if (currentStep.value == 1) {
    currentStep.value = 2
    ElMessageBox.alert('统计完成！', '提示', {
      confirmButtonText: 'OK',
      showClose: false,
    })
    const oriData = [
      {
        name: '通行费电子发票',
        count: 0,
        money: 0,
        actualTax: 0,
        noCount: 0,
        noMoney: 0,
        noActualTax: 0,
      },
      {
        name: '机动车发票',
        count: 0,
        money: 0,
        actualTax: 0,
        noCount: 0,
        noMoney: 0,
        noActualTax: 0,
      },
      {
        name: '增值税专用发票',
        count: 4,
        money: 29747.54,
        actualTax: 2843.46,
        noCount: 0,
        noMoney: 0,
        noActualTax: 0,
      },
    ]
    let count = new Big(0), money = new Big(0), actualTax = new Big(0),
        noCount = new Big(0), noMoney = new Big(0), noActualTax = new Big(0)
    oriData.forEach(e => {
      count = count.plus(e.count)
      money = money.plus(e.money)
      actualTax = actualTax.plus(e.actualTax)
      noCount = noCount.plus(e.noCount)
      noMoney = noMoney.plus(e.noMoney)
      noActualTax = noActualTax.plus(e.noActualTax)
    })
    oriData.push({
      name: '总计',
      count: parseFloat(count.toString()),
      money: parseFloat(money.toString()),
      actualTax: parseFloat(actualTax.toString()),
      noCount: parseFloat(noCount.toString()),
      noMoney: parseFloat(noMoney.toString()),
      noActualTax: parseFloat(noActualTax.toString()),
    })
    tableList.value = oriData
  } else {
    ElMessageBox.alert('请先完成申请统计！', '提示', {
      confirmButtonText: 'OK',
      showClose: false,
    })
  }
}

// 撤销统计
function rollbackStatist() {
  currentStep.value = 0
  tableList.value = []
  resData.value = null
  $emit('exeSaveQa') // 撤销统计后也保存
}

const keyVis = ref(false)

function confirmSign() {
  if (currentStep.value == 2) {
    ElMessageBox.alert('是否确认，确认后当前统计报表将做为申报的依据！', '流程说明', {
      cancelButtonText: '取消',
      showCancelButton: true,
    })
        .then(() => {
          keyVis.value = true
        })
        .catch(() => {
        })
  } else {
    ElMessageBox.alert('请先完成统计查询！', '提示', {
      confirmButtonText: 'OK',
      showClose: false,
    })
  }
}

const resData = ref(null)

function handleSave(password) {
  resData.value = {
    password
  }
  $emit('exeSaveQa')
}

// 爷爷组件，保存成功回调
$on('saveQaSuccess', res => {
  const savedData = res?.serverData?.solution && JSON.parse(res.serverData.solution) || null
  if (savedData?.password) {
    currentStep.value = 3
  } else {
    currentStep.value = 0
  }
})

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = () => {
  return {
    solution: resData.value && JSON.stringify(resData.value) || '',
  }
}
getGrandchildValue.value.fillFinish = () => {
  return Boolean(resData.value?.password)
}

onMounted(() => {
  resData.value = props.currentQa?.solution && JSON.parse(props.currentQa?.solution || "{}") || null
  if (resData.value?.password) { // 已经作答过
    currentStep.value = 3
  }
})

</script>


<style scoped lang="scss">
.component-wrap {
  font-size: 14px;
  color: #333333;

  .gray-ge {
    width: 1200px;
    margin: auto;
    height: 15px;
    background-color: #f7f7f7;
  }

  .head-box {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ebebeb;

    .ins {
      width: 5px;
      height: 21px;
      background-color: #16307a;
      margin-right: 12px;
    }

    .bold {
      color: #333333;
      font-size: 16px;
      font-weight: 700;

      &.radio-box {
        margin-left: 50px;
        position: relative;

        label {
          color: inherit;
          font-size: inherit;
          font-weight: inherit;
        }

        .layer {
          z-index: 3;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
    }

    .red {
      color: #d75452;
      font-size: 16px;
      font-weight: 700;
    }

    .normal {
      font-weight: 400;
      color: #666666;
      font-size: 14px;
    }

    .grow {
      flex-grow: 1;
    }
  }

  .main-box {
    padding: 20px 0;

    .note-txt {
      line-height: 28px;
      color: #666666;
    }

    .main-content {
      .bt-op {
        padding: 50px 0 30px 0;
        display: flex;
        flex-direction: row-reverse;
      }

      .progress-wrap {
        position: relative;
        width: 1080px;
        margin: auto;

        .step-bar {
          position: absolute;
          width: 100%;
          top: 12px;
          z-index: -1;
          height: 13px;
          border-radius: 12px;
          background-image: url("https://static.rhkj.com/renhe_fe/other/310.png");

          .step-bar-active {
            height: 100%;
            background-image: url("https://static.rhkj.com/renhe_fe/other/312.png");
            width: 0;
            transition: width 1s ease;

            &.step1 {
              width: 16.6667%;
            }

            &.step2 {
              width: 50%;
            }

            &.step3 {
              width: 100%;
            }
          }
        }

        .step {
          display: flex;

          .item {
            width: 33.3333%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .s-position {
              width: 40px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #FFFFFF;
              font-size: 20px;
              font-weight: 700;
              background-image: url("https://static.rhkj.com/renhe_fe/other/309.png");
            }

            .s-label {
              font-size: 14px;
              font-weight: 700;
              color: #999999;
              margin-top: 10px;
            }
          }
        }
      }

      .ticket-table {
        margin-top: 30px;

        > h3 {
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          padding-bottom: 16px;
          margin-bottom: 20px;
          border-bottom: 1px solid #ebebeb;
        }

        .table-title {
          display: flex;
          color: #666666;
          line-height: 40px;
          justify-content: space-between;
        }

        table {
          tr {

            td {
              text-align: center;
              border: 1px solid #cacaca;
              line-height: 40px;

              &.count {
                width: 65px;
              }

              &.money {
                width: 184px;
              }

              &.act {
                width: 165px;
              }

              &.out-wrapper {
                width: 370px;
                position: relative;

                .out {
                  position: absolute;
                  border-top: 90px #56627f solid;
                  border-left: 288px #fff solid;
                  padding-left: 80px;
                }

                > span:nth-child(2) {
                  position: absolute;
                  top: 35px;
                  left: 45px;
                  color: #333333;
                  font-weight: 700;
                }

                > span:nth-child(3) {
                  position: absolute;
                  top: 35px;
                  right: 45px;
                  color: #FFFFFF;
                  font-weight: 700;
                }
              }
            }

            &.head {
              background-color: #56627f;

              td {
                height: 44px;
                line-height: 44px;
                border: 1px solid #535a6b;
                color: #FFFFFF;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
  }

  .pane {
    padding-top: 20px;
    display: flex;

    .item {
      width: 196px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      margin-right: 10px;
      border: 1px solid #666;
      border-radius: 5px;

      &.active {
        background: #3bb5ee;
        color: #fff;
        border: 1px solid #3bb5ee;
        font-weight: 700;
      }
    }
  }
}
</style>
